// 查询账号角色类型
export const getAccountRoleType = function (params) {
  return this.$http('get', 'mall/bdOrderReport/getAccountRoleType', params);
}

// 查询报单用户列表
export const queryQdAccountMapPage = function (params) {
  return this.$http('get', 'mall/bdQdAccount/queryQdAccountMapPage', params);
}

// 更新拉黑状态
export const updateForbidFlag = function (params) {
  return this.$http('post', 'mall/bdQdAccount/updateForbidFlag', params);
}

// 查询报单订单统计数据-Web
export const queryOrderReportSum = function (params) {
  // return this.$http('get', 'mall/bdOrderReport/queryOrderReportSum', params);
  return this.$http('post', 'mall/bdOrderReport/queryExportOrderReportSum', params);
}
// 查询报单订单统计数据-专属
export const queryZsOrderReportSum = function (params) {
  return this.$http('post', 'mall/bdOrderReport/queryZsOrderReportSum', params);
}
// 专属查询列表新接口
export const queryZsOrderReportWeb = function (params) {
  return this.$http('post', 'mall/bdOrderReport/queryZsOrderReportWeb', params);
}

// 汇总 all
export const queryOrderReportAllSum = function (params) {
  return this.$http('get', 'mall/bdOrderReport/queryOrderReportAllSum', params);
}

// 查询报单数据-Web
export const queryOrderReportWeb = function (params) {
  return this.$http('get', 'mall/bdOrderReport/queryOrderReportWeb', params);
}
// 
export const queryExportOrderReportWeb = function (params) {
  return this.$http('post', 'mall/bdOrderReport/queryExportOrderReportWeb', params);
}
// ALL
export const queryOrderReportAllWeb = function (params) {
  return this.$http('get', 'mall/bdOrderReport/queryOrderReportAllWeb', params);
}

// 批量删除
export const removeOrderReportWeb = function (params) {
  return this.$http('post', 'mall/bdOrderReport/removeOrderReportWeb', params);
}

// 报单订单-批量返款
export const refundBatch = function (params) {
  return this.$http('post', 'mall/bdOrderReport/refundBatch', params);
}

// 报单订单导入-WEB
export const uploadOrder = function (file, params) {
  const formData = new FormData()
  formData.append('file', file)

  let url = 'mall/bdOrderReport/uploadOrder'
  for (let key in params) {
    url += url.indexOf('?') > -1 ? '&' : '?'
    url += `${key}=${params[key]}`
  }

  return this.$http('post', url, formData);
}

// 导入查询 
export const importQuery = function (file, params) {
  const formData = new FormData()
  formData.append('file', file)

  let url = 'mall/bdOrderReport/importQuery'
  for (let key in params) {
    url += url.indexOf('?') > -1 ? '&' : '?'
    url += `${key}=${params[key]}`
  }

  return this.$http('post', url, formData);
}

// 校验导入第三方编号
export const checkThirdOrderSnWeb = function (file, params) {
  const formData = new FormData()
  formData.append('file', file)

  let url = 'mall/bdOrderReport/checkThirdOrderSnWeb'
  for (let key in params) {
    url += url.indexOf('?') > -1 ? '&' : '?'
    url += `${key}=${params[key]}`
  }

  return this.$http('post', url, formData);
}

export const checkThirdOrderSn = function (params) {
  return this.$http('post', 'mall/bdOrderReport/checkThirdOrderSn', params);
}

// SUP 报单校验（入参与 addSupOrderReportByFormWeb / addSupOrderReportWeb 一致）
export const checkSupOrderReport = function (params, showErrorMsg = true) {
  return this.$http('post', 'mall/supOrderReport/checkSupOrderReport', params, false, showErrorMsg);
}

// 导入删除
export const importDelete = function (file, params) {
  const formData = new FormData()
  formData.append('file', file)

  let url = 'mall/bdOrderReport/importDelete'
  for (let key in params) {
    url += url.indexOf('?') > -1 ? '&' : '?'
    url += `${key}=${params[key]}`
  }

  return this.$http('post', url, formData);
}

// 根据补贴政策ID查询记录
export const queryBdRebateInfo = function (params) {
  return this.$http('get', 'mall/bdRebateInfo/queryBdRebateInfo', params);
}
// 修改补贴政策ID
export const modifyRebateInfoId = function (url) {
  return this.$http('post', `mall/bdOrderReport/modifyRebateInfoId${url}`);
}

// 提报订单-Web
export const addOrderReportWeb = function (params) {
  return this.$http('post', 'mall/bdOrderReport/addOrderReportWeb', params);
}

// H5分页查询报单列表
export const queryOrderReportPageWeb = function (params) {
  return this.$http('get', 'mall/supOrderReport/queryOrderReportPageWeb', params);
}

// 更新渠道备注
export const updateQdRemark = function ({id, qdRemark}) {
  return this.$http('post', `mall/supOrderReport/updateQdRemark?id=${id}&qdRemark=${qdRemark}`);
}

// mall/supOrderReport/addSupOrderReportH5
export const addSupOrderReportH5 = function (params) {
  return this.$http('post', 'mall/supOrderReport/addSupOrderReportH5', params);
}

// WEB按测算单报单接口
export const addSupOrderReportByFormWeb = function (params, showErrorMsg = true) {
  // mall/supOrderReport/addSupOrderReportByFormWeb
  return this.$http('post', 'mall/supOrderReport/addSupOrderReportWeb', params, false, showErrorMsg);
}

// WEB修改报单接口
export const modifySupOrderReportByFormWeb = function (params, showErrorMsg = true) {
  // mall/supOrderReport/modifySupOrderReportByFormWeb
  return this.$http('post', 'mall/supOrderReport/modifySupOrderReportWeb', params, false, showErrorMsg);
}

// 报单订单导入-WEB
export const supUploadOrder = function (file, params) {
  const formData = new FormData()
  formData.append('file', file)

  let url = 'mall/supOrderReport/importSupOrderReport'
  // let url = 'mall/supOrderReport/importSupOrderReportByForm'
  for (let key in params) {
    url += url.indexOf('?') > -1 ? '&' : '?'
    url += `${key}=${params[key]}`
  }

  return this.$http('post', url, formData);
}

// 数据验证
export const validateImportSupOrderReportByForm = function (file, params) {
  const formData = new FormData()
  formData.append('file', file)

  // let url = 'mall/supOrderReport/validateImportSupOrderReportByForm'
  let url = 'mall/supOrderReport/validateImportSupOrderReport'
  for (let key in params) {
    url += url.indexOf('?') > -1 ? '&' : '?'
    url += `${key}=${params[key]}`
  }

  return this.$http('post', url, formData);
}

// ========== 无登录查单接口 ==========
// 高佣商品手动查单
export const queryBdOrderBySnList = function (params) {
  return this.$http('post', 'mall/bdOrderReport/queryOrderSimpleByOrderSnList', params);
}

// 高佣商品文件查单
export const queryBdOrderByFile = function (file, reportStatus) {
  const formData = new FormData()
  formData.append('file', file)
  
  let url = 'mall/bdOrderReport/queryOrderSimpleByFile'
  if (reportStatus !== undefined && reportStatus !== null && reportStatus !== '') {
    url += `?reportStatus=${reportStatus}`
  }
  
  return this.$http('post', url, formData);
}

// 独家爆品手动查单
export const querySupOrderBySnList = function (params) {
  return this.$http('post', 'mall/supOrderReport/queryOrderSimpleByOrderSnList', params);
}

// 独家爆品文件查单
export const querySupOrderByFile = function (file, reportStatus) {
  const formData = new FormData()
  formData.append('file', file)
  
  let url = 'mall/supOrderReport/queryOrderSimpleByFile'
  if (reportStatus !== undefined && reportStatus !== null && reportStatus !== '') {
    url += `?reportStatus=${reportStatus}`
  }
  
  return this.$http('post', url, formData);
}
